import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
// import Auth from '@aws-amplify/auth';  // Import Amplify Auth
import { signOut } from "aws-amplify/auth"

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';

import { useNavigate, Link } from 'react-router-dom';


const MenuBar = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.reload(); // Optionally reloads the page after sign out
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: 'black', zIndex: 1000}}>
      <Toolbar>
        <a href="http://digitalwaterlab.org/" target="new">
          <img 
            src="https://images.squarespace-cdn.com/content/63121bdc04e1e907fe9ed158/a1b80031-f98d-45a6-b078-75ac671238ed/WaterDrop.png?content-type=image%2Fpng" 
            alt="Digital Water Lab Logo" 
            style={{ marginRight: 10, marginTop: 10, marginBottom: 10, height: '40px' }} 
          />
        </a>
        {/* <Typography variant="h6" sx={{ flexGrow: 1, fontFamily: 'Helvetica, Arial, sans-serif', fontWeight: 'light' }}>
          SewerTycoon Detroit
        </Typography> */}

        <Typography 
          variant="h6" 
          sx={{ flexGrow: 1, fontFamily: 'Helvetica, Arial, sans-serif', fontWeight: 'light' }}
          component={Link}
          to="/"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          SewerTycoon Detroit
        </Typography>

        <Tooltip title="Feedback">
          <IconButton
            color="inherit"
            sx={{ marginRight: 2 }}
            onClick={() => navigate('/feedback')}
          >
            <QuestionAnswerIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Sign Out">
          <IconButton
            color="inherit"
            onClick={handleSignOut} 
            sx={{ marginRight: 2 }}
          >
            <AccountCircleIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Tooltip>

      </Toolbar>
    </AppBar>
  );
};

export default MenuBar;